export const parseFullName = (fullName: string) => {
  const nameParts = fullName.trim().split(' ');
  const fName = nameParts[0] || '';
  const mName = nameParts.length === 3 ? nameParts[1] : '';
  const lName = nameParts.length === 3 ? nameParts[2] : nameParts[1] || '';

  return { fName, mName, lName };
};
